import { RouteConfig } from "vue-router";
import {
  RExpertServicesTemplate,
  RCandidateServicesTemplate,
} from "@/modules/Services/Template/RServicesTemplate";
import {
  RExpertServicesBrowse,
  RCandidateServicesBrowse,
} from "@/modules/Services/Browse/RServisesBrowse";

export const RExpertServices: RouteConfig = {
  path: "cases",
  component: () =>
    import(
      /* webpackChunkName: "expert-cases" */
      "./VServices.vue"
    ),
  meta: {
    title: "Services",
    icon: "briefcase-outline",
    newIcon: "file-certificate",
  },
  children: [RExpertServicesBrowse, RExpertServicesTemplate],
};

export const RCandidateServices: RouteConfig = {
  path: "cases",
  component: () =>
    import(
      /* webpackChunkName: "expert-cases" */
      "./VServices.vue"
    ),
  meta: {
    title: "Cases",
    icon: "briefcase-outline",
    newIcon: "file-certificate",
  },
  children: [RCandidateServicesBrowse, RCandidateServicesTemplate],
};
